// Utility functions to generate structured data for SEO

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "AF Pictures",
  "url": "https://afpictures.com",
  "logo": "https://afpictures.com/img/white-regular@2x.svg",
  "description": "Empresa de distribuciรณn cinematogrรกfica especializada en la promociรณn y distribuciรณn de pelรญculas independientes",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "ES"
  },
  "sameAs": [
    // Add social media URLs here when available
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "availableLanguage": ["Spanish", "English"]
  }
});

export const generateWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "AF Pictures",
  "url": "https://afpictures.com",
  "description": "Distribuciรณn cinematogrรกfica profesional",
  "publisher": {
    "@type": "Organization",
    "name": "AF Pictures"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://afpictures.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
});

export const generateMovieSchema = (project) => {
  if (!project) return null;
  
  return {
    "@context": "https://schema.org",
    "@type": "Movie",
    "name": project.name,
    "description": project.description ? project.description.replace(/<[^>]*>/g, '') : '',
    "image": project.image_thumb?.url || project.image_bg_thumb?.url,
    "url": `https://afpictures.com/cine/${project.slug}`,
    "dateCreated": project.created_at,
    "productionCompany": {
      "@type": "Organization",
      "name": "AF Pictures"
    },
    "genre": "Cinema",
    "inLanguage": "es"
  };
};

export const generateVideoObjectSchema = (project) => {
  if (!project || !project.yt?.resourceId?.videoId) return null;
  
  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": project.name,
    "description": project.description ? project.description.replace(/<[^>]*>/g, '') : '',
    "thumbnailUrl": project.image_thumb?.url,
    "uploadDate": project.created_at,
    "duration": "PT0M0S", // Update with actual duration if available
    "embedUrl": `https://www.youtube.com/embed/${project.yt.resourceId.videoId}`,
    "publisher": {
      "@type": "Organization",
      "name": "AF Pictures",
      "logo": {
        "@type": "ImageObject",
        "url": "https://afpictures.com/img/white-regular@2x.svg"
      }
    }
  };
};

export const generateBreadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": crumb.url
  }))
});

export const generateCollectionPageSchema = (category, projects) => ({
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": `${category} - AF Pictures`,
  "description": `Catálogo de películas de ${category.toLowerCase()} distribuidas por AF Pictures`,
  "url": `https://afpictures.com/${category.toLowerCase()}`,
  "mainEntity": {
    "@type": "ItemList",
    "numberOfItems": projects?.length || 0,
    "itemListElement": projects?.slice(0, 10).map((project, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "url": `https://afpictures.com/${category.toLowerCase()}/${project.slug}`,
      "name": project.name
    })) || []
  }
});

export const generateServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Servicios de Distribución Cinematográfica",
  "description": "Servicios profesionales de distribución de películas, promoción cinematográfica y gestión de catálogos audiovisuales",
  "provider": {
    "@type": "Organization",
    "name": "AF Pictures"
  },
  "serviceType": "Distribución cinematográfica",
  "areaServed": "ES"
});
